import React, { useState, useEffect } from "react";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { Button } from "primereact/button";
import { InputText } from "primereact/inputtext";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import moment from "moment";
import DetallePeriodoCobro from "./DetallePeriodoCobro";

const CierreTable = ({
  asignaciones,
  filters,
  loading,
  actionBodyTemplate,
  fila,
  setFila,
  displayBasic,
  setDisplayBasic,
  baseUrl,
  urlMedidores,
  urlDocumentos,
  monedaOptions,
  valorUfUsada,
  isMonedaServiceUnavailable,
  buttonTemplate,
  handleFetchAllData,
  selectedEmpresa,
  setLoading,
  diaFin,
  diaCobro,
  empresa,
  previousPeriodo,
  periodoDeCobro,
  toast,
}) => {
  const [first, setFirst] = useState(0);
  const [tableKey, setTableKey] = useState(0);
  const [detallesCobro, setDetallesCobro] = useState([]);
  const [modalLoading, setModalLoading] = useState(false);
  const [summary, setSummary] = useState({});
  const [error, setError] = useState(null);
  const [globalFilter, setGlobalFilter] = useState('');
  const today = moment();
  const [exportLoading, setExportLoading] = React.useState(false);
  const fechaDeEmision = today.format("DD/MM/YYYY");
  const vencimiento = moment(periodoDeCobro)
    .locale("es")
    .date(25)
    .format("DD/MM/YYYY");
  const ufItem = monedaOptions?.find(
    (moneda) => moneda?.descripcion === "Unidad de Fomento"
  );
  const ufTipoCambio =
    Number.isFinite(Number(valorUfUsada)) && Number(valorUfUsada) > 0
      ? Number(valorUfUsada)
      : ufItem
        ? ufItem?.tipoCambio
        : 0;
  
  useEffect(() => {
    setFirst(0);
    setTableKey((prevKey) => prevKey + 1);
  }, [selectedEmpresa]);


  const handleOpenDialog = async (rowData) => {
    setFila(rowData);
    setDisplayBasic(true);
    setModalLoading(true);
    setError(null);
    try {
      const response = await fetch(
        `${baseUrl}getDetalleCobroByIdPeriodoFacturacion?idPeriodo=${rowData.id}`
      );
      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }
      const data = await response.json();
      if (data.respuesta) {
        setDetallesCobro(data.detallesCobro);
        calculateSummary(data.detallesCobro, monedaOptions);
      } else {
        setDetallesCobro([]);
        setSummary({});
        setError("No data found.");
      }
    } catch (error) {
      console.error("Error fetching data", error);
      setDetallesCobro([]);
      setSummary({});
      setError(error.message);
    }
    setModalLoading(false);
  };

  const formatNumber = (amount) => {
    return new Intl.NumberFormat("es-CL", {
      minimumFractionDigits: 2,
      maximumFractionDigits: 2,
    }).format(amount);
  };

  const calculateSummary = (detalles, monedaOptions) => {
    const summary = {
      total: 0, // Sum of all amounts in UF
      totalClp: 0, // Sum of all amounts converted to CLP
      arriendoTotal: 0, // Sum of all amounts converted to CLP
      gastoComunTotal: 0, // Sum of all amounts converted to CLP
      serviciosTotal: 0, // Sum of all amounts converted to CLP
      obrasCivilesTotal: 0, // Sum of all amounts converted to CLP
    };

    detalles.forEach((detalle) => {
      let monedaUf = monedaOptions.find((m) => m.codigo === "UF");
      let moneda = monedaOptions.find((m) => m.codigo === detalle.moneda);

      if (moneda) {
        let amountInUF =
          moneda.codigo === "UF"
            ? detalle.total
            : detalle.total / monedaUf.tipoCambio;

        let amountInCLP = detalle.total * moneda.tipoCambio.toFixed(2);

        if (detalle.servicios === "arriendo") {
          summary.arriendoTotal += amountInUF;
        } else if (detalle.servicios === "gasto comun") {
          summary.gastoComunTotal += amountInUF;
        } else if (detalle.servicios === "servicio") {
          summary.serviciosTotal += amountInUF;
        } else if (detalle.servicios === "obra civil") {
          summary.obrasCivilesTotal += amountInUF;
        }

        summary.total += amountInUF;
        summary.totalClp += amountInCLP;
      }
    });
    setSummary(summary);
  };

  //detalles de cotizacion
  const arriendoDescriptions = detallesCobro
    .filter(
      (item) => item?.servicios === "arriendo" && !item?.item.includes(" - ")
    ) // Filter items where servicios is "arriendo"
    .map((item) => item?.item) // Map to get the descripcion
    .join(" / "); // Join descriptions with a comma and space
  const arriendoItems = detallesCobro.filter(
    (item) => item.servicios === "arriendo"
  );
  const gastoComunItems = detallesCobro.filter(
    (item) => item.servicios === "gasto comun"
  );
  const serviciosItems = detallesCobro.filter(
    (item) => item.servicios === "servicio"
  );
  const obrasCivilesItems = detallesCobro.filter(
    (item) => item.servicios === "obra civil"
  );
  const basicDialogFooter = (
    <div
      style={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
      }}
    >
      <Button
        type="button"
        label="Cerrar"
        onClick={() => setDisplayBasic(false)}
        icon="pi pi-times"
        className="p-button-rounded p-button-outlined mr-2 mb-2 mt-2"
        autoFocus
      />
    </div>
  );

  const exportToPDF = async () => {
    setExportLoading(true);
    const input = document.getElementById("dialog-content");
    if (!input) {
      console.error("Element with ID 'dialog-content' not found");
      return;
    }

    // Cargar logo desde public/logoCBQ.png (ruta segura con PUBLIC_URL)
    const logoUrl = `${process.env.PUBLIC_URL}/logoCBQ.png`;

    html2canvas(input, { scale: 2 })
      .then(async (canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "mm", "a4");
        const imgWidth = 190; // A4 width minus margins (210 - 20)
        const pageHeight = 297;
        const imgHeight = (canvas.height * imgWidth) / canvas.width;
        let heightLeft = imgHeight;
        let position = 30; // deja espacio para el logo

        // Agregar logo PNG al PDF (cargado desde public)
        try {
          const resp = await fetch(logoUrl);
          const blob = await resp.blob();
          const logoDataUrl = await new Promise((resolve) => {
            const reader = new FileReader();
            reader.onloadend = () => resolve(reader.result);
            reader.readAsDataURL(blob);
          });
          pdf.addImage(logoDataUrl, "PNG", 10, 10, 40, 20); // ajusta tamaño/posición si necesitas
        } catch (e) {
          console.warn("No se pudo cargar el logo desde public/logoCBQ.png", e);
        }

        // Contenido capturado con html2canvas
        pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
        heightLeft -= pageHeight - 30;

        while (heightLeft >= 0) {
          position = heightLeft - imgHeight + 10;
          pdf.addPage();
          pdf.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
          heightLeft -= pageHeight - 30;
        }

        const pdfData = pdf.output("bloburl");
        window.open(pdfData);
      })
      .catch((error) => {
        console.error("Error generating PDF:", error);
      });
  };

  const altamiraDetails = `
  Banco: ITAU
  Rut: 76.071.007-5
  Nombre: ALTAMIRA SA
  Tipo de Cuenta: Corriente
  N° Cuenta: 2120941106
  `;
    const siembraDetails = `
    Banco: ITAU
    Rut: 76.066.122-8
    Nombre: SOC AGRIC E INMOBILIARIA LA SIEMBRA LTDA
    Tipo de Cuenta: Corriente
    N° Cuenta: 223286902
  `;

  const handleCopyDetails = () => {
    const detailsToCopy =
      selectedEmpresa === "ALTAMIRA" ? altamiraDetails : siembraDetails;
    navigator.clipboard.writeText(detailsToCopy).then(() => {
      alert("Detalles copiados al portapapeles");
    });
  };

  const postMediciones = async (consumoMedidores) => {
    try {
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json");

      const raw = JSON.stringify(consumoMedidores);

      const requestOptions = {
        method: "POST",
        headers: myHeaders,
        body: raw,
        redirect: "follow",
        credentials: "include", 
      };

      const response = await fetch(
        `${baseUrl}actualizarMediciones?periodo=${previousPeriodo}&empresa=${selectedEmpresa}&valorUf=${ufTipoCambio}`,
        requestOptions
      );
      if (!response.ok) {
        throw new Error(
          `Failed to update mediciones! status: ${response.status}`
        );
      }
      await handleFetchAllData();
    } catch (error) {
      console.error("Error:", error);
      throw error;
    }
  };

  const handleSincronizar = async () => {
    setLoading(true);
    try {
      const myHeaders = new Headers();

      const requestOptions = {
        method: "GET",
        headers: myHeaders,
        redirect: "follow",
        credentials: "include", 
      };

      const consumoMedidoresResponse = await fetch(
        `${urlMedidores}getDetallePeriodo?periodoMedicion=${previousPeriodo}`,
        requestOptions
      );

      if (!consumoMedidoresResponse.ok) {
        throw new Error(
          `Failed to fetch consumo medidores! status: ${consumoMedidoresResponse.status}`
        );
      }

      const response = await consumoMedidoresResponse.json();

      // si no hay mediciones, avisar y cortar
      const detalles = Array.isArray(response?.detalles) ? response.detalles : [];
      if (detalles.length === 0) {
        toast.current.show({ severity: 'warn', summary: 'Advertencia', detail: 'No se encontraron mediciones para el período seleccionado.', life: 3000 });
        setLoading(false);
        return;
      }
      
      await postMediciones(detalles);
      toast.current.show({ severity: 'success', summary: 'Éxito', detail: 'Sincronización completada correctamente', life: 3000 });
      setLoading(false);
    } catch (error) {
      console.error("Error:", error);
      toast.current.show({ severity: 'error', summary: 'Error', detail: 'Ocurrió un error al sincronizar', life: 3000 });
      setLoading(false);
    }
  };

  const sendDataToSystem = async (rowData) => {
    // console.log("Contenido de rowData:", rowData);
    if (rowData.enviado !== 0) {
      alert(`Esta asignación ya fue enviada a facturador.`);
      return;
    }
    try {
      setLoading(true);

      const responseEnviado = await fetch(
        `${baseUrl}getEnviadoValueById?idPeriodoFacturacion=${rowData.id}`
      );

      if (!responseEnviado.ok) {
        throw new Error(
          `Error al verificar enviado: ${responseEnviado.status}`
        );
      }

      const dataEnviado = await responseEnviado.json();
      if (!dataEnviado.respuesta) {
        alert(`Error: ${dataEnviado.mensaje}`);
        return;
      }

      if (dataEnviado.enviado !== 0) {
        alert(`Esta asignación ya fue enviada a facturador.`);
        return;
      }

      if (!rowData.cerrada) {
        const userConfirmed = window.confirm(
          "Esta asignación no tiene valores en sus mediciones. ¿Desea enviarla igualmente?"
        );

        if (!userConfirmed) {
          return;
        }
      }

      const items = await fetch(
        `${baseUrl}getDetalleCobroByIdPeriodoFacturacion?idPeriodo=${rowData.id}`
      );

      if (!items.ok) {
        throw new Error(`HTTP error! status: ${items.status}`);
      }
      
      const data = await items.json();

      const productos = (data.detallesCobro || []).flatMap((detalle) => {
        
        if (
          detalle.item.includes("Agua") ||
          detalle.item.includes("Electricidad")
        ) {
          return [];
        }

        return [
          {
            docCobro: detalle.docCobro,
            item: detalle.servicios === "arriendo" ? `Arriendo - ${detalle.item}` : detalle.item,
            total: parseFloat(
              (
                // (detalle.item.includes("Agua") || detalle.item.includes("Electricidad")) &&
                // parseFloat(detalle.consumo) > 0
                //   ? parseFloat(detalle.totalClp) / parseFloat(detalle.consumo)
                //   :
                parseFloat(detalle.totalClp)
              ).toFixed(2)
            ),
            cantidad:
              // detalle.item.includes("Agua") || detalle.item.includes("Electricidad")
              //   ? detalle.consumo
              //   :
              1,
            unidadMedida: detalle.unidadMedida,
            lectInicial: detalle.lectInicial,
            lectFinal: detalle.lectFinal,
            consolidado: detalle.consolidado,
            agrupamiento: detalle.agrupamiento,
          },
        ];
      });

      //generar documento de payload
      const documento = {
        productos
      };

      const payload = [
        {
          descripcionContrato: `${rowData.idCotizacion}`,
          rut: empresa.rut,
          rutFuncionario: empresa.rut,
          documento: documento,
          periodo: moment(periodoDeCobro).format("YYYY-MM"),
          inicioPago: diaCobro,
          finPago: diaFin,
          fechaEmision: moment().format("YYYY-MM-DD"),
          fechaVencimiento: moment().add(5, "days").format("YYYY-MM-DD"),
          valorUf: ufTipoCambio,
          rutContraparte: rowData.cliente.rut,
          razonSocialContraparte: rowData.cliente.razonSocial,
          giroContraparte: rowData.cliente.giro,
          comunaContraparte: rowData.domicilios[0]?.comuna
            ? rowData.domicilios[0].comuna
            : "No tiene comuna",
          codigoSucursal: 1,
          primer_mes: rowData.primer_mes,
        },
      ];

      // Set both Authorization and Content-Type headers
      const myHeaders = new Headers();
      myHeaders.append("Content-Type", "application/json"); // This tells the server you're sending JSON

      //formato total a 2 decimales
      let cuerpo = JSON.stringify(payload);
      cuerpo = cuerpo.replace(/("total":)(\d+)(?=[,}])/g, '$1$2.0');

      //console.log("Cuerpo final enviado a guardarDetalleDocumento:", cuerpo);
      const response = await fetch(
        `${urlDocumentos}guardarDetalleDocumento`,
        {
          method: "POST",
          headers: myHeaders,
          body: cuerpo,
          redirect: "follow",
          credentials: "include" // importante para enviar la cookie SSO al otro subdominio
        }
      );

      if (response.ok) {
        // Marcar todas las asignaciones como enviadas
        let marcarEnvioSuccess = true;
        const marcarEnvioResponse = await fetch(
          `${baseUrl}marcarEnvioAsignacion?idPeriodoFacturacion=${rowData.id}&idUsuarioSender=${sessionStorage.getItem("usuario_id")}`,
          {
            method: "PUT",
            headers: {
              "Content-Type": "application/json",
            },
            credentials: "include",
          }
        );

        if (!marcarEnvioResponse.ok) {
          marcarEnvioSuccess = false;
        } else {
          const marcarEnvioResult = await marcarEnvioResponse.json();
          if (!marcarEnvioResult.respuesta) {
            marcarEnvioSuccess = false;
          }
        }
        if (marcarEnvioSuccess) {
          alert("Data insertada correctamente en facturador.");
        } else {
          alert(
            "Data insertada correctamente en facturador pero no pudo ser marcada en bodegas."
          );
        }
        
      } else {
        const errorMessage = await response.text();
        alert(`Error inserting data: ${errorMessage}`);
        throw new Error(`Failed to send data: ${response.status}`);
      }
    } catch (error) {
      console.error("Error sending data to system:", error);

    } finally {
      setLoading(false);
      handleFetchAllData();
    }
  };

  const [mostrarEnUf, setMostrarEnUf] = useState(true);

  return (
    <div>
       {/* BOTONES DE CABECERA */}
        <div className="p-col mt-3" style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: "1rem" }}>
          <div className="p-input-icon-left" style={{ flex: "1", marginRight: "1rem" }}>
            <i className="pi pi-search" />
            <InputText 
              placeholder="Buscar por Cliente..." 
              style={{ width: "30%"}}
              value={globalFilter ? globalFilter.toUpperCase() : ""}
              onChange={(e) => setGlobalFilter(e.target.value.toUpperCase())}
            />
          </div>
          <div style={{ display: "flex", gap: "1rem" }}>
            <Button
              label={mostrarEnUf ? "Mostrar en CLP" : "Mostrar en UF"}
              icon="pi pi-exchange"
              className="p-button-secondary p-button p-button-rounded"
              onClick={() => setMostrarEnUf(!mostrarEnUf)}
              disabled={loading || isMonedaServiceUnavailable}
              raised
            />
            <Button
              label="Sincronizar"
              icon={loading ? "pi pi-spinner" : "pi pi-refresh"}
              className="p-button p-button-rounded"
              onClick={() => handleSincronizar()}
              disabled={loading || isMonedaServiceUnavailable}
              raised
            />
          </div>
        </div>

        {/* TABLA Cierre de periodo */}
        <div className="col-12">
          <DataTable
            header={`Se encontraron ${asignaciones.length} asignaciones`}
            showGridlines
            key={tableKey}
            value={asignaciones}
            paginator
            first={first}
            rows={10}
            rowsPerPageOptions={[10, 20, 50, 100]}
            paginatorTemplate="FirstPageLink PrevPageLink PageLinks NextPageLink LastPageLink RowsPerPageDropdown CurrentPageReport"
            currentPageReportTemplate="Mostrando {first} a {last} de {totalRecords} asignaciones"
            dataKey="id"
            filters={filters}
            filterDisplay="menu"
            loading={loading}
            scrollable
            emptyMessage="No se encontraron registros."
            rowClassName="row-clickable"
            className="p-datatable-gridlines"
            onRowClick={(e) => handleOpenDialog(e.data)}
            globalFilter={globalFilter}
            stripedRows="true"
            scrollHeight="57vh"
          >
            <Column
              field="id"
              header="Asignación"
              style={{ minWidth: "7rem" }}
              body={(rowData) => (<span><strong>Folio</strong> {rowData.folio}<br/><strong>ID</strong> {rowData.idCotizacion}</span>)}
            />

            <Column
              field="cliente.razonSocial"
              header="Cliente"
              style={{ minWidth: "7rem" }}
              body={(rowData) => rowData.cliente.razonSocial}
              sortable
            />

            <Column
              header="Metodo de pago"
              body={() => <span>Facturas separadas</span>}
            />

            <Column
              header="Arriendo"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              body={(rowData) => {
                const clp = rowData.detalles.arriendo_clp || 0;
                const uf = rowData.detalles.arriendo_uf || 0;
                const total = mostrarEnUf
                  ? uf + clp / ufTipoCambio
                  : clp + uf * ufTipoCambio;
                return mostrarEnUf
                ? `UF ${formatNumber(total)}`
                : `$ ${Math.round(total).toLocaleString("es-CL")}`;
              }}
            />

            <Column
              header="Gasto Común"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              body={(rowData) => {
                const clp = rowData.detalles.gasto_comun_clp || 0;
                const uf = rowData.detalles.gasto_comun_uf || 0;
                const valorUf = ufTipoCambio || 1;
                const total = mostrarEnUf
                  ? uf + clp / valorUf
                  : clp + uf * valorUf;
                return mostrarEnUf
                ? `UF ${formatNumber(total)}`
                : `$ ${Math.round(total).toLocaleString("es-CL")}`;
              }}
            />
            <Column
              header="Servicio"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              body={(rowData) => {
                const clpServicio = rowData.detalles.servicio_clp || 0;
                const ufServicio = rowData.detalles.servicio_uf || 0;
                const clpInternet = rowData.detalles.internet_clp || 0;
                const ufInternet = rowData.detalles.internet_uf || 0;
                const valorUf = ufTipoCambio || 1;
                const total = mostrarEnUf
                  ? ufServicio +
                    ufInternet +
                    (clpServicio + clpInternet) / valorUf
                  : clpServicio +
                    clpInternet +
                    (ufServicio + ufInternet) * valorUf;
                return mostrarEnUf
                ? `UF ${formatNumber(total)}`
                : `$ ${Math.round(total).toLocaleString("es-CL")}`;
              }}
            />
            <Column
              header="Obra Civil"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              body={(rowData) => {
                const clp = rowData.detalles.obra_clp || 0;
                const uf = rowData.detalles.obra_uf || 0;
                const valorUf = ufTipoCambio || 1;
                const total = mostrarEnUf
                  ? uf + clp / valorUf
                  : clp + uf * valorUf;
                return mostrarEnUf
                ? `UF ${formatNumber(total)}`
                : `$ ${Math.round(total).toLocaleString("es-CL")}`;
              }}
            />
            <Column
              header="Total"
              style={{ whiteSpace: "nowrap", overflow: "hidden", textOverflow: "ellipsis" }}
              body={(rowData) => {
                const valorUf = ufTipoCambio || 1;
                const arriendoClp = rowData.detalles.arriendo_clp || 0;
                const arriendoUf = rowData.detalles.arriendo_uf || 0;
                const gastoClp = rowData.detalles.gasto_comun_clp || 0;
                const gastoUf = rowData.detalles.gasto_comun_uf || 0;
                const servicioClp = rowData.detalles.servicio_clp || 0;
                const servicioUf = rowData.detalles.servicio_uf || 0;
                const internetClp = rowData.detalles.internet_clp || 0;
                const internetUf = rowData.detalles.internet_uf || 0;
                const obraClp = rowData.detalles.obra_clp || 0;
                const obraUf = rowData.detalles.obra_uf || 0;

                const total = mostrarEnUf
                  ? (arriendoClp +
                      gastoClp +
                      servicioClp +
                      internetClp +
                      obraClp) /
                      valorUf +
                    arriendoUf +
                    gastoUf +
                    servicioUf +
                    internetUf +
                    obraUf
                  : (arriendoUf + gastoUf + servicioUf + internetUf + obraUf) *
                      valorUf +
                    arriendoClp +
                    gastoClp +
                    servicioClp +
                    internetClp +
                    obraClp;

                    return mostrarEnUf
                    ? `UF ${formatNumber(total)}`
                    : `$ ${Math.round(total).toLocaleString("es-CL")}`;
                  }}
            />

            <Column
              header="Cierre"
              body={actionBodyTemplate}
            />
            <Column header="Reproceso" body={buttonTemplate}/>

            <Column
              header="Estado"
              body={(rowData) => {
                // Suma simple de todos los subtotales: si es 0, deshabilitamos el botón
                const isZeroTotal =
                  [
                    rowData.detalles?.arriendo_clp,
                    rowData.detalles?.arriendo_uf,
                    rowData.detalles?.gasto_comun_clp,
                    rowData.detalles?.gasto_comun_uf,
                    rowData.detalles?.servicio_clp,
                    rowData.detalles?.servicio_uf,
                    rowData.detalles?.internet_clp,
                    rowData.detalles?.internet_uf,
                    rowData.detalles?.obra_clp,
                    rowData.detalles?.obra_uf,
                  ].reduce((sum, v) => sum + (Number(v) || 0), 0) === 0;

                return (
                  <Button
                    label={rowData.enviado ? "Enviado" : "Por Enviar"}
                    icon={`pi ${rowData.enviado ? 'pi-check-circle' : 'pi-clock'}`}
                    className={`p-button-rounded p-button ${rowData.enviado ? 'p-button-success' : 'p-button-warning'}`}
                    onClick={() => sendDataToSystem(rowData)}
                    disabled={loading || isZeroTotal || isMonedaServiceUnavailable}
                    tooltip={
                      rowData.enviado
                        ? `Enviado el ${moment(rowData.fechaEnvio).format('DD/MM/YYYY HH:mm')}`
                        : isMonedaServiceUnavailable
                          ? 'No disponible: servicio de monedas del período'
                          : ''
                    }
                    tooltipOptions={{ position: 'top' }}
                    style={{
                      minWidth: '120px',
                      transition: 'all 0.3s ease',
                      backgroundColor: rowData.enviado ? 'rgba(76, 175, 80, 0.1)' : 'rgba(255, 167, 38, 0.1)',
                      color: rowData.enviado ? '#2E7D32' : '#E65100',
                      border: `1px solid ${rowData.enviado ? '#4CAF50' : '#FFA726'}`,
                    }}
                  />
                );
              }}
              style={{ 
                minWidth: "12rem", 
                textAlign: "center"
              }}
            />

          </DataTable>
        </div>
      
      <DetallePeriodoCobro
        displayBasic={displayBasic}
        setDisplayBasic={setDisplayBasic}
        basicDialogFooter={basicDialogFooter}
        modalLoading={modalLoading}
        error={error}
        fila={fila}
        arriendoDescriptions={arriendoDescriptions}
        periodoDeCobro={periodoDeCobro}
        fechaDeEmision={fechaDeEmision}
        vencimiento={vencimiento}
        summary={summary}
        selectedEmpresa={selectedEmpresa}
        handleCopyDetails={handleCopyDetails}
        ufTipoCambio={ufTipoCambio}
        arriendoItems={arriendoItems}
        gastoComunItems={gastoComunItems}
        serviciosItems={serviciosItems}
        obrasCivilesItems={obrasCivilesItems}
        exportToPDF={exportToPDF}
        exportLoading={exportLoading}
      />
    </div>
  );
};

export default CierreTable;
